import React from "react";
import { Alert, Card, Col, Popover, Row, Space, Typography } from "antd";
import { InfoCircleOutlined, WarningOutlined } from "@ant-design/icons";
import { TScanResult } from "../../types";
import { eResultCode, eWARRANTY_STATUS } from "../../utils/enum";
import DateUtils from "../../utils/date";
import styles from "./ScanResultCard.module.css";
import { eL1OUTPUTMSGS } from "../../pages/dashboard/evaluation/l1-form";

const { Title, Text } = Typography;

interface ScanResultCardProps {
  scanResult: TScanResult;
  outputStyle: React.CSSProperties;
  context: any;
  timeStamp: Date;
}

const ScanResultCard: React.FC<ScanResultCardProps> = ({
  scanResult,
  outputStyle,
  context,
  timeStamp,
}) => {
  const content = (
    <div>
      <p>
        <strong>Warranty Date:</strong>{" "}
        {scanResult?.warrantyDateString
          ? scanResult?.warrantyDateString
          : "N/A"}
      </p>
      <p>
        <strong>Scanned/Received Date:</strong>{" "}
        {scanResult?.scannedDate
          ? DateUtils.format(
              scanResult?.scannedDate,
              context?.user?.dateFormat,
              true
            )
          : "N/A"}
      </p>
      <p>
        <strong>Manufacturing Date:</strong>{" "}
        {scanResult?.manufacturingDate
          ? DateUtils.format(
              scanResult?.manufacturingDate,
              context?.user?.dateFormat
            )
          : "N/A"}
      </p>
    </div>
  );

  return (
    <Card className={styles.scanResultCard} bodyStyle={{ padding: 0 }}>
      <div className={styles.logHeader}>
        <Popover
          content={content}
          title="Scan Details"
          trigger="hover"
          getPopupContainer={(trigger) => trigger.parentElement as HTMLElement}
        >
          <InfoCircleOutlined className={styles.logIcon} />
        </Popover>
        <div>
          {/* {scanResult?.responseCode === eResultCode.R_DUPLICATE || (
            <Row
              justify="space-between"
              align="middle"
              style={{ marginBottom: "0.5rem" }}
            >
              <Col>
                <Space
                  direction="horizontal"
                  align="center"
                  size="middle"
                  style={{ padding: "6px" }}
                >
                  <WarningOutlined
                    style={{
                      fontSize: "14px",
                      color: "var(--bs-danger)",
                    }}
                  />
                  <Title
                    level={5}
                    style={{
                      color: "var(--bs-danger)",
                      margin: 0,
                      textAlign: "center",
                    }}
                  >
                    {scanResult?.responseMsg}
                  </Title>
                </Space>
              </Col>
            </Row>
          )} */}
          <div style={outputStyle}>
            <Title level={5} style={{ color: "white" }}>
              {scanResult.warrantyMessage}
            </Title>
          </div>
          {scanResult.warrantyStatus ===
            eWARRANTY_STATUS.IN_WARRANTY_CLAIMED && (
            <Alert
              message={eL1OUTPUTMSGS.CLAIMEDANDINWARRANTY}
              type="success"
              showIcon
              style={{ marginTop: "1rem" }}
            />
          )}
          {scanResult.warrantyStatus === eWARRANTY_STATUS.OUT_OF_WARRANTY && (
            <Alert
              message={eL1OUTPUTMSGS.NOTWARRANTYNOTCLAIMED}
              type="warning"
              showIcon
              style={{ marginTop: "1rem" }}
            />
          )}
          {/* <div>
            <Text strong>Warranty Date:</Text>{" "}
            <Text>
              {scanResult?.warrantyDateString
                ? scanResult?.warrantyDateString
                : "N/A"}
            </Text>
          </div>
          <div>
            <Text strong>Scanned/Received Date:</Text>{" "}
            <Text>
              {scanResult?.scannedDate
                ? DateUtils.format(
                    scanResult?.scannedDate,
                    context?.user?.dateFormat,
                    true
                  )
                : "N/A"}
            </Text>
          </div> */}
        </div>
      </div>
      <div className={styles.logFooter}>
        <Text className={styles.logTimestamp}>
          {DateUtils.format(timeStamp, context?.user?.dateFormat, true)}
        </Text>
      </div>
    </Card>
  );
};

export default ScanResultCard;
